import { MediaQueries } from 'components/MediaQueries';
import styled from 'styled-components';

const PostArrowBack = styled.div`
  display: flex;
  align-items: center;
  position: sticky;
  top: 55px;
  height: 35px;
  border-radius: 2px;
  z-index: 1;
  background-color: ${({ theme }) => theme.tab2};
  color: ${({ theme }) => theme.text1};
  transition: top 0.7s;
  > div:first-child {
    margin: 0 8px;
  }
`;

const ContentBox = styled.div`
  width: 100%;
`;

const PostHeader = styled.div`
  .MuiButtonBase-root.Mui-selected {
    color: #1976d2 !important;
  }
  .MuiBox-root {
    margin-top: 8px;
    position: sticky;
    top: 55px;
    z-index: 1;
    opacity: 0.9;
    .MuiTabs-root {
      max-width: ${() =>
        screen.availWidth < 600 ? `${screen.availWidth - 15}px` : 'none'};
    }
  }
  .MuiTabs-flexContainer {
    justify-content: center;
  }
  .MuiTabScrollButton-root {
    display: none;
  }
  .MuiTabs-indicator {
    display: none;
  }
  .MuiTabs-root {
    min-height: 40px;
  }
  .MuiTab-root {
    border-radius: 8px;
    padding: 0px 19%;
    min-height: 40px;
  }
  .hide-post-tab-label {
    .MuiBox-root {
      display: none;
    }
  }
  @media only screen and (max-width: 600px) {
    .MuiTab-root {
      padding: 0px 15%;
    }
    .MuiTabs-root {
      margin: 0 8px;
      max-width: ${() =>
        screen.availWidth < 600
          ? `${screen.availWidth - 16}px`
          : 'none'} !important;
    }
  }
`;

const PostBox = styled.div`
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.boxShadow1};
  .upload-block {
    padding-top: 8px;
    &:hover {
      cursor: pointer;
      background: ${({ theme }) =>
        theme.mode === 'light' ? '#F8F8F8' : '#1c1c1c'};
      border-radius: 10px;
    }
  }
  @media screen and (max-width: 599px) {
    margin: 0px 8px;
    .upload-block {
      padding-top: 4px;
      button {
        width: 95%;
        padding: 8px;
        font-size: 15px;
      }
      .icon-title {
        font-size: 14px;
        margin-left: 5px;
        color: ${({ theme }) => theme.colors[2]};
      }
      .PostIcons {
        padding: 0;
        svg {
          width: 18px;
          height: 18px;
        }
      }
    }
    &.profile-page-container {
      margin: 0 auto;
      width: 96%;
      box-shadow: none;
      > div {
        padding: 0px;
      }
    }
    &.job-page-container {
      box-shadow: none;
      margin: 0;
    }
    &.business-page-container {
      box-shadow: none;
      margin: 0;
    }
    &.job-applied-page-container {
      box-shadow: none;
      margin: 0;
    }
    &.notification-page-container {
      box-shadow: none;
      margin: 0;
    }
  }
`;

const PostImage = styled.div`
  position: relative;
  margin: 0 8px 8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border1};

  &:hover {
    background-color: ${({ theme }) => theme.lightGrayHover};
  }

  .preview-parent,
  .preview-parent3 {
    width: 100%;
    display: grid;
    overflow: hidden;
  }
  .preview-parent {
    grid-template-columns: auto auto;
  }
  .preview-parent3 {
    grid-template-columns: 50% 50%;
    gap: 1px;
    img {
      border-radius: 4px;
    }
  }
  .preview-child {
    cursor: pointer;
    position: relative;
    height: ${(props) => (props.imglength > 4 ? '150px' : '300px')};
    img {
      height: ${(props) => (props.imglength > 4 ? '150px' : '300px')};
      object-fit: cover;
    }
    .preview-img-count {
      width: 40px;
      height: 40px;
      bottom: 4px;
      right: 5px;
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      position: absolute;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #11111199;
    }
  }
  .img-index0 {
    height: 300px;
    grid-row: 1 / span 2;
    grid-column: 1;
    img {
      width: 100%;
      height: 300px;
      object-fit: cover;
    }
  }
  .img-index1,
  .img-index2 {
    width: 100%;
    height: 150px;
    position: relative;
    img {
      width: 100%;
      height: 150px;
      object-fit: cover;
    }
  }
  .img-len4 {
    width: 100%;
    height: 150px;
    position: relative;
    img {
      width: 100%;
      height: 150px;
      object-fit: cover;
    }
  }
  .singleimgparent {
    display: flex;
    justify-content: center;
  }
  .single-img {
    max-height: 500px;
    img {
      min-height: 200px;
      max-width: 100%;
      max-height: 500px;
      object-fit: cover;
    }
  }
  .ant-image-mask {
    display: none;
  }
  .ant-image {
    width: 100%;
    height: 100%;
  }
`;

const PostInput = styled.button`
  width: 97.5%;
  margin: 8px 8px 0px;
  padding: 10px 15px;
  border: 1px solid ${({ theme }) => theme.colors[5]};
  border-radius: 30px;
  color: ${({ theme }) => theme.colors[2]};
  font-size: 15px;
  // font-weight: 500;
  text-align: start;
  background: transparent;
  cursor: pointer;
`;

const PostIcons = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: fit-content;
  padding: 0 10px 0 10px;
  flex-wrap: wrap;
  .PreviewPost {
    &:nth-child(2) svg path {
      fill: ${({ theme }) =>
        theme.mode === 'light' ? 'rgb(9, 36, 75)' : 'rgb(35 95 181)'};
    }
  }
`;

const PreviewPost = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  svg {
    width: 20px;
    height: 20px;
  }
  .icon-title {
    font-size: 15px;
    margin-left: 5px;
    color: ${({ theme }) => theme.text1};
  }
`;

const ButtonIconView = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 50px;
  cursor: ${(props) => (props.disabledbtn ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabledbtn ? 0.8 : 1)} !important;
  &:hover {
    background: ${(props) =>
      props.disabledbtn ? 'none' : props.theme.lightGrayHover};
  }
  .post-video-icon svg path {
    fill: ${({ theme }) =>
      theme.mode === 'light' ? 'rgb(9, 36, 75)' : 'rgb(35 95 181)'};
  }
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .attachment-icon {
    height: 20px;
  }
  .icon-title {
    color: ${(props) =>
      props.disabledbtn ? props.theme.disableText1 : props.theme.text1};
  }
`;

const PostActionIcons = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  .post-icons {
    cursor: pointer;
    border-radius: 50px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background-color: ${({ icon }) =>
        icon === 'Comment'
          ? '#fef3d4'
          : icon === 'Like' || icon === 'Unlike'
          ? '#FFE6E5'
          : '#cbe7ff'};
      svg path {
        fill: ${({ icon }) =>
          icon === 'Comment'
            ? '#d4a92f'
            : icon === 'Like' || icon === 'Unlike'
            ? '#ec6a8f'
            : '#0a7cef'};
        stroke: ${({ icon }) => icon === 'Detail' && '#0a7cef'};
      }
    }
  }
  .post-disable-icon {
    cursor: auto;
    svg path {
      fill: ${({ theme }) => theme.disableBg1};
    }
    &:hover {
      background-color: transparent;
      svg path {
        fill: ${({ theme }) => theme.disableBg1};
      }
    }
  }
  .commentIcon {
    width: 16px;
    height: 16px;
  }
  .thumbIcon {
    width: 21px;
    height: 21px;
  }
  .detailIcon {
    width: 17px;
    height: 17px;
  }
  svg {
    path {
      fill: ${({ icon, theme }) => (icon === 'Unlike' ? '#ec6a8f' : '#828282')};
    }
  }
  .postActionCount {
    font-size: 14px;
    color: #828282;
    width: 10px;
    cursor: auto;
    text-align: center;
  }
  .like-count-action:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  // Like Animation
  .like-icon-wrapper {
    display: inline-block;
    position: relative;
  }
  
  .like-icon-animate {
    animation: thumbsPop 0.6s ease-out;
  }
  
  @keyframes thumbsPop {
    0% {
      transform: scale(1) rotate(0deg);
      opacity: 1;
    }
    30% {
      transform: scale(1.3) rotate(-10deg);
    }
    60% {
      transform: scale(0.95) rotate(5deg);
    }
    80% {
      transform: scale(1.1) rotate(-2deg);
    }
    100% {
      transform: scale(1) rotate(0deg);
    }
  }
`;

const IconView = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.modal ? '0px 10px' : '6px 10px')};
  margin-top: ${(props) => (props.modal ? '0px' : '5px')};
  cursor: ${(props) => (props.disabledbtn ? 'inherit' : 'pointer')};
  &:hover {
    background: ${(props) => (props.disabledbtn ? '#fff' : '#ebebeb')};
    border-radius: 5px;
  }

  .post-icons {
    svg {
      fill: ${({ theme }) => theme.colors[2]};
    }
  }

  .icon-view,
  .icon-like {
    font-size: 22px;
    display: flex;
    > img {
      width: 15px;
    }
  }

  .icon-title {
    font-size: 13px;
    font-weight: 500;
    margin-left: 5px;
    pointer-events: none;
    cursor: ${(props) => (props.disabledbtn ? 'inherit' : 'pointer')};
    color: ${(props) => (props.disabledbtn ? '#cacaca' : '#333')};
  }
  .share-ic {
    display: flex;
    align-items: center;
    font-size: 20px;
    transform: rotate(-20deg);
    position: relative;
    top: -1px;
  }
  .acticon-view {
    > div {
      > svg {
        width: 15px;
        position: relative;
        top: 3px;
        > g g path {
          stroke: ${(props) => props.disabledbtn && '#cacaca'};
        }
      }
    }
  }
`;

const StatusContainer = styled.div`
  margin: 0px;
  .profile {
    margin: 0px;
  }
  .spinner {
    color: red;
  }
  .act-drop-style {
    z-index: 2;
    background: red;
  }
  .post-lazy-container {
    margin: 8px 0px;
    padding: 8px;
    border-radius: 10px;
    // box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,
    //   rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
    box-shadow: ${({ theme }) => theme.boxShadow1};
    .lazy-d-flex {
      display: flex;
      align-items: center;
    }
    .lazy-content {
      margin: 10px 0;
    }
    .lazy-name {
      margin-left: 4px;
      > span:nth-child(2) {
        margin-top: 4px;
      }
    }
    .lazy-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .lazy-d-flex {
        > span {
          margin-right: 24px;
        }
      }
    }
  }
  /* @media only screen and (max-width: ${MediaQueries.tabletMaxwidth}) {
    max-width: 100%;
  } */
`;

const EndStyle = styled.div`
  color: ${({ theme }) => theme.fieldBorder1};
  display: block;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  width: ${({ customWidth }) => customWidth || '100%'};
  padding: ${({ customPadding }) => customPadding || '8px 0px 8px'};
  &:before {
    width: 100px;
    height: 0;
    content: ' ';
    display: inline-block;
    border-top: 1px solid ${({ theme }) => theme.border1};
    vertical-align: super;
  }
  &:after {
    width: 100px;
    height: 0;
    content: ' ';
    display: inline-block;
    border-top: 1px solid ${({ theme }) => theme.border1};
    vertical-align: super;
  }
  > span {
    padding: 0 20px;
    position: relative;
    top: 4px;
  }
`;

const StatusBox = styled.div`
  border-radius: 10px;
  margin: 8px 0px;
  box-shadow: ${({ theme }) => theme.boxShadow1};
  color: ${({ theme }) => theme.text1};
  @media only screen and (max-width: 599px) {
    margin: 8px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  position: relative;
  .about-info {
    width: 100%;
    display: flex;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    .post-time {
      font-size: 13px;
      position: relative;
      top: 3px;
      margin-left: 5px;
      color: #828282;
      white-space: nowrap;
    }
  }
  .post-more-btn {
    svg path:nth-child(2) {
      fill: #828282;
    }
    &:hover {
      background-color: ${({ theme }) => theme.hoverBg1};
    }
  }
`;

const UserProfile = styled.div`
  min-width: ${(props) => props.width || 40}px;
  min-height: ${(props) => props.height || 40}px;
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.border1};
    object-fit: contain;
  }
  svg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: contain;
    padding: 0px 1px;
    path {
      fill: ${({ theme }) => theme.svg2};
    }
  }
  .profile-img {
    border-radius: 50%;
  }
`;

const UserQuickPreview = styled.div`
  padding: 12px;
  border-radius: 8px;
  width: 180px;
  .quick-preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-size: 14px;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  .quick-preview-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #ebebeb;
  }
  .quick-preview-svgpic {
    border-radius: 50%;
    path {
      fill: ${({ theme }) => theme.svg2};
    }
  }
  .quick-preview-seeprofile {
    color: #1976d2;
  }
  .quick-preview-displayname {
    margin-top: 4px;
    font-size: 15px;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .quick-preview-username {
    font-size: 14px;
    position: relative;
    top: -4px;
    color: #858585;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .quick-preview-headline {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .quick-preview-follow-container {
    margin-top: 9px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }
`;

const UserDetails = styled.div`
  margin-left: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  .post-displayname-flex {
    display: flex;
  }
  &.username-suggestion {
    width: 80%;
  }
  .display-name {
    font-size: 14px;
    margin-top: 2px;
    font-weight: 500;
    color: ${({ theme }) => theme.text1};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
    @media only screen and (max-width: 500px) {
      font-size: 13px !important;
    }
  }
  .user-role {
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .user-name {
    font-size: 13px;
    font-weight: 400;
    color: #828282;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .followers {
    margin-top: 2px;
    font-size: 13px;
    font-weight: 400;
    color: #828282;
  }
`;

const SharePost = styled.div`
  cursor: pointer;
  font-size: 16px;
  .action-popover {
    top: 0;
    right: 45px;
  }

  .menu-pop-over {
    right: 50px;
    top: 0px;
  }

  .menu-box {
    width: 130px;
  }

  .removePadding {
    padding: 0px;
  }
`;

const PostMessageStyle = styled.div`
  padding: 0px 10px 8px 10px;
  .post-history-title {
    color: ${({ theme }) => theme.text1};
    font-size: 18px;
    font-weight: 600;
  }
  .description-line-clamp {
    width: auto;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .comments {
    overflow: visible;
    height: auto;
  }
  .see-more-container {
    width: 100%;
    text-align: end;
  }
  .see-more {
    color: #1976d2;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
  }
`;

const AboutAction = styled.div`
  display: flex;
  align-items: center;
  margin: 0 8px;
  padding-bottom: 8px;
  justify-content: space-between;
  div:nth-child(1) {
    display: flex;
  }
  .share-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #828282;
    cursor: pointer;
    border-radius: 50px;
    width: 75px;
    height: 26px;
    svg {
      width: 16px;
      height: 16px;
      margin-right: 6px;
      path {
        fill: #828282;
      }
    }
    &:hover {
      color: #0a7cef;
      background-color: #cbe7ff;
      svg path {
        fill: #0a7cef;
      }
    }
  }
`;

const ImageContainer = styled.div`
  text-align: center;
  border: 1px solid #ebebeb;
  width: 450px;
  margin: 0 auto 25px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const DocumentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 12px 8px;
  .fileName {
    font-size: 16px;
    font-weight: 500;
    color: grey;
  }
  .fileContent {
    display: flex;
    justify-content: space-between;
  }
  .actionIcons {
    display: flex;
  }
`;

const contentStyle = {
  height: '200px',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
};

const PriorityStyle = styled.div`
  font-size: 15px;
  border-radius: 10px;
  color: ${({ theme }) => theme.text1};
  box-shadow: ${({ theme }) => theme.boxShadow1};
  .suggestion-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
  }
  > div {
    padding: 12px 8px 0px;
  }
  > div:nth-child(2) {
    padding: 0px 8px 0px;
    height: calc(100vh - (72px + 24px + 50px));
    overflow-y: auto;
    overflow-x: hidden;
  }
  .user-role {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .about-info {
    width: 69%;
  }
`;

const DDItem = styled.li`
  display: flex;
  list-style-type: none;
  align-items: center;
  justify-content: flex-start;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  svg {
    width: 20px;
  }
  > div:nth-child(1) {
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  > div:nth-child(2) {
    padding-left: 8px;
  }
  &:hover {
    background-color: ${({ theme }) => theme.lightGrayHover};
  }
`;

const PostPopOver = styled.div`
  width: ${(props) => (props['data-is-user-info-loading'] ? '200px' : 'auto')};
  height: ${(props) => (props['data-is-user-info-loading'] ? '200px' : 'auto')};
  .post-more-spinner {
    padding: 0px;
  }
  font-size: 15px;
  color: ${({ theme }) => theme.text1};
  > div:not(.post-more-spinner) {
    display: flex;
    padding: 10px 12px;
    align-items: center;
    min-width: 140px;
    cursor: pointer;
    border-radius: 8px;
    > div {
      max-width: 200px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
    &:not(.post-mute-icon) {
      svg {
        width: 21px;
        height: 21px;
        margin-right: 12px;
        fill: ${({ theme }) => theme.svg1};
      }
      g path {
        fill: ${({ theme }) => theme.svg1} !important;
      }
    }
    .post-block-icon {
      width: 18.5px;
      height: 18.5px;
    }
  }
  .post-mute-icon {
    svg {
      width: 22px;
      height: 22px;
      margin-right: 11px;
      color: ${({ theme }) => theme.svg1};
    }
  }
  .job-share {
    svg {
      width: 18px !important;
      height: 18px !important;
    }
  }

  .editlist-icon {
    fill: ${({ theme }) => theme.svg1};
  }
  .deletelist-icon {
    svg {
      fill: ${({ theme }) => theme.red1} !important;
    }
    color: ${({ theme }) => theme.red1} !important;
  }
  .disable-action {
    cursor: default !important;
    color: ${({ theme }) => theme.disableText1};
    svg {
      fill: ${({ theme }) => theme.disableText1} !important;
    }
  }
`;

const PosthistoryStyle = styled.div`
  ${PostBox} {
    padding: 8px;
    margin: 8px 0;
    .edited-text {
      font-size: 16px;
      div {
        color: ${({ theme }) => theme.colors[2]};
        padding: 8px 0;
        font-size: 18px;
        font-weight: 600;
      }
      span {
        font-size: 14px;
        color: #828282;
      }
    }
  }
  .post-history-profile {
    padding: 8px 0px;
    @media only screen and (max-width: 599px) {
      width: 90vw;
    }
  }
`;
const PostLikeListStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > div {
    display: flex;
    align-items: center;
  }
  ${UserDetails} {
    .user-name {
      padding-bottom: 3px;
    }
    border-bottom: ${(props) => (props.length ? '1px' : '0px')} solid #ebebeb;
  }
  .sug-foll-btn {
    > button {
      background-color: #2d90ff;
      color: ${({ theme }) => theme.Bg1};
      border-radius: 50px;
      height: 32px;
      min-width: 80px;
      font-weight: bold;
      font-size: 13px;
      padding: 5px 10px;
    }
  }
`;

export {
  PostArrowBack,
  ContentBox,
  PostHeader,
  PostBox,
  PostInput,
  PostIcons,
  IconView,
  ButtonIconView,
  PostActionIcons,
  PreviewPost,
  StatusContainer,
  StatusBox,
  UserInfo,
  UserProfile,
  UserQuickPreview,
  UserDetails,
  SharePost,
  PostMessageStyle,
  AboutAction,
  ImageContainer,
  DocumentContainer,
  contentStyle,
  PriorityStyle,
  PostImage,
  EndStyle,
  DDItem,
  PostPopOver,
  PosthistoryStyle,
  PostLikeListStyle,
};
